<template>
    <el-dialog
        :visible.sync="dialogVisible"
        width="800px"
        top="40vh"
        :show-close="false"
        :append-to-body="true"
        :before-close="handleClose">
        <div class="confirm-content">
            <div class="header">
                <img src="@/assets/images/busImage/fail.png"/>
                <span>错误信息</span>
            </div>
            <div class="info">
               <div class="tips">{{errorMessage}}</div>
            </div>
            <slot></slot>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props: {
        errorMessage: {
            type: String,
            required: true
        },
        dialogVisible: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {}
    },
    methods: {
        handleClose(){
            this.$emit('handleClose')
        }
    }
}
</script>

<style lang="less" scoped>
    .confirm-content {
        text-align: center;
        .header {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin-bottom: 30px;
            span {
                margin-left: 12px;
                font-weight: 500;
                font-size: 32px;
                color: rgba(0,0,0,0.85);
            }
        }
        .info {
            .tips {
                margin-left: 12px;
                font-weight: 500;
                font-size: 28px;
                line-height: 45px;
                text-align: center;
                color: rgba(0,0,0,0.85);
                span{
                    margin: 0 5px;
                    color: #BE5852;
                }
            }
        }
        
    }
    /deep/ .el-dialog__header {
        padding: 0;
    }
</style>


